/**
 *  02/09/2019 v 1.0 - JuanMa
 *  V.1.1 11/09/2019 Añadidos mejoras para ordenar por tipo en  getFuncionOrdenacionPorNombreCampo
 *  v.1.2 28/02/2020 Añadida funcion ordenarPorPropiedadCadena
 *  v.1.3 03/08/2020 Modificada la función getFuncionOrdenacionPorCampo, para tener en cuenta el caso de una Foreign.
 *                   Modificada la función getFuncionOrdenacionPorCampo para corregir los valores null.
 *  v.2.0 02/08/2021 Modificada la funcion de ordenacion para distinguir si es un Foreign o un foreignJPA y obtener el valor con el método adecuado.
 **/



import {CELLTIPO_CADENA, CELLTIPO_ENTERO, CELLTIPO_FLOTANTE, CELLTIPO_MONEDA, CELLTIPO_PORCENTAJE, CELLTIPO_FECHA, CELLTIPO_FECHAHORA
} from "../UI/TiposCeldas";
import {stringPorcentajeToNumber, stringMonedaToNumber, stringFechaHoraToNumber} from "./StringUtils"
import {esForeign, esForeignJPA, getCampoDeForeign, getForeign, getValorDeForeign} from "./ForeignUtils";
import {getValorPropiedad} from "./ObjectUtils";


export const ordenarConIndiceCampo= (columnas, datos, indiceCampo, direccion) => {

    console.log ("ordenconindice: " + indiceCampo);
    if (datos.length > 0) {
        //let nombreCampo=  Object.keys(datos[0])[indiceCampo];
        let campoOrdenacion=  columnas[indiceCampo];
        console.log(campoOrdenacion);
        return ordenarConCampo(datos, campoOrdenacion, direccion);
    }
}


export const ordenarConCampo= (datos, campo, direccion) => {
    let newDatos = [];
    let nombreCampoConOrden= campo.campo;
    switch (direccion.toUpperCase()) {
        case "ASC": break;
        case "DESC": nombreCampoConOrden= "-" + nombreCampoConOrden; break;
        default: break;
    }
    newDatos = datos.sort(getFuncionOrdenacionPorCampo(campo, direccion));
    return newDatos;
}



export const getFuncionOrdenacionPorCampo= (campo, direccion) => {
    var sortOrder = 1;
    switch (direccion.toUpperCase()) {
        case "ASC": break;
        case "DESC": sortOrder = -1; break;
        default: break;
    }

    return function (a, b) {
        let valorA = a[campo.campo];
        let valorB = b[campo.campo];

        //Si es Foreign obtenemos el valor usando la función getValorPropiedad.
        if (esForeignJPA(campo.campo)){
            if (esForeign(campo.campo)){
                valorA = getValorDeForeign(campo.campo, a);
                valorB = getValorDeForeign(campo.campo, b);
            }
            else {
                valorA = getValorPropiedad(a, campo.campo);
                valorB = getValorPropiedad(b, campo.campo);
            }
        }


        //Correcciones para no tener el valor null
        if (!valorA)
            valorA= "";
        if (!valorB)
            valorB= "";

        switch (campo.tipo) {
            case CELLTIPO_ENTERO:
            case CELLTIPO_FLOTANTE:
                valorA = Number(a[campo.campo]);
                valorB = Number(b[campo.campo]);
                break;

            case CELLTIPO_PORCENTAJE:
                valorA = stringPorcentajeToNumber(a[campo.campo]);
                valorB = stringPorcentajeToNumber(b[campo.campo]);
                break;

            case CELLTIPO_MONEDA:
                valorA = stringMonedaToNumber(a[campo.campo]);
                valorB = stringMonedaToNumber(b[campo.campo]);
                break;
        }

        //console.log("ORDENANDO ", campo.campo);
        //console.log(valorA, " - ", valorB);

        let result = (valorA < valorB) ? -1 : (valorA > valorB) ? 1 : 0;
        return result * sortOrder;
    }
}


export const ordenarPorPropiedadCadena= (datos, propiedadNombre, direccion) => {
    let newDatos = [];
    newDatos = datos.sort((a,b) => {
        let valorA = a[propiedadNombre];
        let valorB = b[propiedadNombre];
        let result = (valorA < valorB) ? -1 : (valorA > valorB) ? 1 : 0;
        return result;
        }
    );
    if (direccion === "DESC")
        newDatos= newDatos.reverse();
    return newDatos;
}
